<div class="page-shell">
<mat-toolbar class="header">
  <span>
    {{ ("menu.type." + filters.viewType) | translate }}: {{ total }}
  </span>

  <div class="actions">
    <button mat-stroked-button (click)="openEmployeeRequestDialog()">
      <mat-icon>send</mat-icon>
      {{'employee.sendRequest.label' | translate}}
    </button>
    <button mat-stroked-button (click)="openEmployeeManager()">
      <mat-icon>people</mat-icon>
      {{ 'settings.integration.employeeManagement.title' | translate }}
    </button>
    <button mat-stroked-button (click)="downloadAllSignatures()">
      <mat-icon>download</mat-icon>
      {{ 'employee.downloadAllSignatures' | translate }}
    </button>
  </div>
</mat-toolbar>

<div class="employees-wrapper">
  <div class="filters-row">
    <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
      <input
        matInput
        [formControl]="phraseControl"
        [placeholder]="'employee.searchPlaceholder' | translate"
        [attr.aria-label]="'employee.search' | translate"
      />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <div class="filter-chips-wrap">
      <div class="filter-chip" *ngFor="let f of getActiveFilters()">
        <span class="filter-chip-label">{{ f.label }}</span>
        <button mat-icon-button class="filter-chip-remove" (click)="removeFilter(f.key)" type="button" [attr.aria-label]="'remove' | translate">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <button mat-stroked-button [matMenuTriggerFor]="filterMenu" (menuOpened)="loadFilterData()" class="filter-trigger-btn">
        <mat-icon>filter_list</mat-icon>
        {{ 'employee.filters.button' | translate }}
        <span class="filter-badge" *ngIf="activeFiltersCount > 0">{{ activeFiltersCount }}</span>
      </button>
    </div>
  </div>

  <mat-menu #filterMenu="matMenu" class="employee-filter-menu" xPosition="before" [overlapTrigger]="false">
    <div class="filter-menu-panel" (click)="$event.stopPropagation()">
      <div class="filter-menu-grid">
        <app-searchable-select
          [label]="'employee.filterBySignature' | translate"
          [value]="filters.templateId ?? defaultSignatureFilter"
          (valueChange)="filterBySignature($event)"
          [options]="allSignatures"
          [displayWith]="signatureLabel"
          [valueWith]="signatureValue"
          [emptyLabel]="'-'"
          [emptyValue]="undefined"
        ></app-searchable-select>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'employee.filterByHasSignature.label' | translate }}</mat-label>
          <mat-select (selectionChange)="addFilter('signatureInstalled', $event.value)" [value]="filters.signatureInstalled">
            <mat-option [value]="undefined">{{ 'employee.filterByHasSignature.ALL' | translate }}</mat-option>
            <mat-option value="ONLY_ENABLED">{{ 'employee.filterByHasSignature.ONLY_ENABLED' | translate }}</mat-option>
            <mat-option value="ONLY_DISABLED">{{ 'employee.filterByHasSignature.ONLY_DISABLED' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'employee.filterByExcluded.label' | translate }}</mat-label>
          <mat-select (selectionChange)="addFilter('excludedFromSignatures', $event.value)" [value]="filters.excludedFromSignatures">
            <mat-option [value]="undefined">{{ 'employee.filterByExcluded.ALL' | translate }}</mat-option>
            <mat-option value="ONLY_ENABLED">{{ 'employee.filterByExcluded.ONLY_ENABLED' | translate }}</mat-option>
            <mat-option value="ONLY_DISABLED">{{ 'employee.filterByExcluded.ONLY_DISABLED' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <app-searchable-select
          [label]="'employee.filterByGroup.label' | translate"
          [value]="filters.groupEmail"
          (valueChange)="addFilter('groupEmail', $event)"
          [options]="groupEmails.data || []"
          [displayWith]="identityLabel"
          [valueWith]="identityLabel"
          [emptyLabel]="'employee.filterByGroup.ALL' | translate"
          [emptyValue]="undefined"
          [loading]="groupEmails.loading"
        ></app-searchable-select>

        <app-searchable-select
          [label]="'employee.filterByUnit.label' | translate"
          [value]="filters.orgUnitPath"
          (valueChange)="addFilter('orgUnitPath', $event)"
          [options]="units.data || []"
          [displayWith]="unitLabel"
          [valueWith]="unitValue"
          [searchWith]="unitSearchLabel"
          [emptyLabel]="'employee.filterByUnit.ALL' | translate"
          [emptyValue]="undefined"
          [loading]="units.loading"
        ></app-searchable-select>

        <app-searchable-select
          [label]="'employee.filterByBranch.label' | translate"
          [value]="filters.branchId"
          (valueChange)="addFilter('branchId', $event)"
          [options]="branches.data || []"
          [displayWith]="branchLabel"
          [valueWith]="branchValue"
          [emptyLabel]="'employee.filterByBranch.ALL' | translate"
          [emptyValue]="undefined"
          [loading]="branches.loading"
        ></app-searchable-select>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'employee.viewSelection.label' | translate }}</mat-label>
          <mat-select [value]="filters.viewType" (selectionChange)="toggleView($event.value)">
            <mat-select-trigger>{{ getViewTypeText(filters.viewType) }}</mat-select-trigger>
            <mat-option value="EMPLOYEES">{{ 'employee.viewSelection.viewEmployees' | translate }}</mat-option>
            <mat-option value="ALIASES">{{ 'employee.viewSelection.viewAliases' | translate }}</mat-option>
            <mat-option value="BOTH">{{ 'employee.viewSelection.viewBoth' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-menu>

  <div
    class="table-container"
    [class.table-container--loading]="isLoading$ | async"
    [class.table-container--empty]="!(isLoading$ | async) && dataSource.data.length === 0"
  >
    <mat-table (matSortChange)="sortChange($event)" matSort [dataSource]="dataSource" class="employees-table">
    <ng-container matColumnDef="fullName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'employee.fullName' | translate}}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="company-wrapper">
        <div *ngIf="element.fullName">{{ element.fullName }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{'employee.email' | translate}}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div *ngIf="element.email">{{ element.email }}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="type">
      <mat-header-cell *matHeaderCellDef>{{ 'employee.type' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="type-cell">
          <ng-container *ngIf="element.isAlias; else sourceBlock">
            <mat-icon class="type-icon type-icon-alias">alternate_email</mat-icon>
          </ng-container>
          <ng-template #sourceBlock>
            <ng-container [ngSwitch]="element.dataSource">
              <ng-container *ngSwitchCase="'SAMPLE'">
                <mat-icon class="type-icon">visibility</mat-icon>
              </ng-container>
              <ng-container *ngSwitchCase="'LOCAL'">
                <mat-icon class="type-icon">person</mat-icon>
              </ng-container>
              <ng-container *ngSwitchCase="'GOOGLE'">
                <img src="assets/img/google-logo.svg" alt="Google" class="type-source-logo" />
              </ng-container>
              <ng-container *ngSwitchCase="'MICROSOFT'">
                <img src="assets/img/microsoft-logo.svg" alt="Microsoft" class="type-source-logo" />
              </ng-container>
              <ng-container *ngSwitchCase="'CALAMARI'">
                <img src="assets/img/calamari.svg" alt="Calamari" class="type-source-logo" />
              </ng-container>
              <ng-container *ngSwitchDefault>
                <mat-icon class="type-icon">work</mat-icon>
              </ng-container>
            </ng-container>
          </ng-template>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'employee.createdAt' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="table-cell-stack">
        <div *ngIf="element.createdAt" class="date-time-container">
          <div>{{ element.createdAt | localizedDate:'mediumDate' }},</div>
          <div>{{ element.createdAt | localizedDate:'mediumTime' }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="signatureInstallationAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'employee.signatureInstallationAt' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="table-cell-stack">
        <div *ngIf="element.signatureInstallationAt" class="date-time-container">
          <div>{{ element.signatureInstallationAt | localizedDate:'mediumDate' }},</div>
          <div>{{ element.signatureInstallationAt | localizedDate:'mediumTime' }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="modifiedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'employee.modifiedAt' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="table-cell-stack">
        <div *ngIf="element.modifiedAt" class="date-time-container">
          <div>{{ element.modifiedAt | localizedDate:'mediumDate' }},</div>
          <div>{{ element.modifiedAt | localizedDate:'mediumTime' }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="templateId">
      <mat-header-cell *matHeaderCellDef>
        {{ 'employee.templateIdColumn' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="signature-cell">
        <ng-container *ngIf="element.templateId || element.internalTemplateId; else noSignature">
          <div class="signature-grid" [class.loading-overlay]="removingSignatureTemplates.has(removeSignatureKey(element))">
            <div class="signature-loading-overlay" *ngIf="removingSignatureTemplates.has(removeSignatureKey(element))">
              <mat-spinner diameter="24" class="signature-spinner"></mat-spinner>
            </div>
            <ng-container *ngIf="element.templateId">
              <div class="signature-row">
                <div class="signature-label-column" matTooltip="{{ 'externalSignature' | translate }}">
                  <mat-icon aria-label="external" class="icon-muted">launch</mat-icon>
                </div>
                <div class="signature-name-column">
                  <a class="chip"
                     [title]="(signatureNamePerId$ | async)?.get(element.templateId)"
                     [routerLink]="['/signatures', element.templateId]"
                     data-table-no-row-nav
                     (click)="$event.stopPropagation()">
                    {{ (signatureNamePerId$ | async)?.get(element.templateId) }}
                  </a>
                </div>
                <div class="signature-close-column">
                  <button mat-icon-button class="remove-signature-button"
                          aria-label="Remove signature template"
                          (click)="removeSignatureTemplate(element); $event.stopPropagation()"
                          [disabled]="removingSignatureTemplates.has(removeSignatureKey(element))"
                          matTooltip="{{ 'employee.removeSignatureTemplate' | translate }}">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="element.internalTemplateId">
              <div class="signature-row">
                <div class="signature-label-column" matTooltip="{{ 'internalSignature' | translate }}">
                  <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" class="icon-muted">
                    <title>{{ 'signatures.internalInstallationsTooltip' | translate }}</title>
                    <path d="M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7z"/>
                    <path d="M16 15v-2h-3.59L20 5.41l-1.41-1.41L11 11.59V8h-2v7h7z" />
                  </svg>
                </div>
                <div class="signature-name-column">
                  <a class="chip"
                     [title]="(signatureInternalNamePerId$ | async)?.get(element.internalTemplateId)"
                     [routerLink]="['/signatures', element.internalTemplateId]"
                     data-table-no-row-nav
                     (click)="$event.stopPropagation()">
                    {{ (signatureInternalNamePerId$ | async)?.get(element.internalTemplateId) }}
                  </a>
                </div>
                <div class="signature-close-column">
                  <button mat-icon-button class="remove-signature-button"
                          aria-label="Remove internal signature template"
                          (click)="removeInternalSignatureTemplate(element); $event.stopPropagation()"
                          [disabled]="removingSignatureTemplates.has(removeSignatureKey(element))"
                          matTooltip="{{ 'employee.removeInternalSignatureTemplate' | translate }}">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #noSignature>
          <span>-</span>
        </ng-template>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="signatureAccepted">
      <mat-header-cell *matHeaderCellDef>{{'employee.signatureAccepted' | translate}}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-checkbox [disabled]="true" [checked]="element.signatureAccepted" color="primary"></mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="excludedFromSignatures">
      <mat-header-cell *matHeaderCellDef [matTooltip]="'employee.excludedFromSignaturesTooltip' | translate">
        {{ 'employee.excludedFromSignatures' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="checkbox-container">
          <mat-checkbox *ngIf="!element.isAlias && !processingEmployees.has(element.employeeId)"
            [disabled]="!element.canBeExcludedFromSignatures"
            (click)="$event.stopPropagation()"
            (change)="$event ? changeExcludedFromSignatures($event.checked, element) : null"
            [checked]="element.excludedFromSignatures"
            [matTooltip]="element.canBeExcludedFromSignatures ? ('employee.excludedFromSignaturesTooltip' | translate) : ('employee.cannotBeExcludedFromSignatures' | translate)"
            color="primary">
          </mat-checkbox>
          <mat-spinner *ngIf="!element.isAlias && processingEmployees.has(element.employeeId)" diameter="16" class="checkbox-spinner"></mat-spinner>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef>
        <div class="checkbox-container">
          <mat-checkbox *ngIf="canExcludeAnyEmployee && !isExcludingAll"
            (change)="toggleExcludeAll($event.checked)"
            [checked]="isAllExcluded"
            [indeterminate]="isSomeExcluded"
            [disabled]="!canExcludeAnyEmployee"
            [matTooltip]="'employee.excludeAllSignatures' | translate"
            color="primary">
          </mat-checkbox>
          <mat-spinner *ngIf="canExcludeAnyEmployee && isExcludingAll" diameter="16" class="checkbox-spinner"></mat-spinner>
        </div>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="table-actions" *ngIf="!element.isAlias">
          <a
            class="action-btn"
            [routerLink]="['/employees']"
            [queryParams]="{ employeeId: element.employeeId }"
            queryParamsHandling="merge"
            data-table-no-row-nav
            (click)="$event.stopPropagation()"
          >
            <mat-icon>edit</mat-icon>
            {{ 'edit' | translate }}
          </a>
        </div>
      </mat-cell>
    </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"
        [ngClass]="{'alias-row': row.isAlias, 'tall-row': row.templateId && row.internalTemplateId}"
        [appTableRowLink]="employeeDetailLink(row)"
        [appTableRowLinkQueryParams]="employeeDetailQueryParams(row)"
        appTableRowLinkQueryParamsHandling="merge">
      </mat-row>
    </mat-table>

    <div class="loading-wrapper" *ngIf="isLoading$ | async">
      <app-loading></app-loading>
    </div>

    <div class="empty-state" *ngIf="!(isLoading$ | async) && dataSource.data.length === 0">
      <mat-icon class="empty-state__icon">people</mat-icon>
      <p>{{ 'employee.noEmployees' | translate }}</p>
    </div>
  </div>

  <mat-paginator
    *ngIf="total > 0"
    [pageSizeOptions]="pageSizeOptions"
    [length]="total"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    (page)="changePage($event)"
  ></mat-paginator>
</div>
</div>
